import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { Skeleton, notification } from "antd"

import RunSummary from "./components/RunSummary"
import FinalizeBatchTable from "./components/FinalizeBatchTable"
import FinalizeResult from "./components/FinalizeResult"
import {
    fetchFinalizePlan,
    fetchRunBills,
    flagRecheckSummary,
    recheckFlags,
    selectFinalizePlan,
    selectFinalizePlanLoading,
} from "./clientBatchingSlice"

export default function RunFinalizePage() {
    const dispatch = useDispatch()
    const { runId } = useParams()
    const plan = useSelector(selectFinalizePlan)
    const loading = useSelector(selectFinalizePlanLoading)

    useEffect(() => {
        const load = async () => {
            // Red flags BEFORE the plan, not alongside it: the re-check can move bills in or out of
            // the run, and a plan built first would be stale (and rejected) at commit.
            const flags = await dispatch(recheckFlags(runId))
            const moved = flagRecheckSummary(flags)
            if (moved) notification.info({ message: "Red flags re-checked", description: `${moved}.` })

            // The run header comes from the bills endpoint. persistPagination: false because this
            // is a header-only fetch -- without it the review grid is left on one row a page.
            dispatch(fetchRunBills(runId, { pagination: { current: 1, pageSize: 1 }, persistPagination: false }))
            dispatch(fetchFinalizePlan(runId))
        }
        load()
    }, [dispatch, runId])

    return (
        <div>
            <RunSummary />
            <div style={{ marginTop: "20px" }}>
                {loading && !plan ? <Skeleton active /> : plan && plan.finalized ? <FinalizeResult /> : <FinalizeBatchTable />}
            </div>
        </div>
    )
}
